import { createStore } from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import service from '@/service/index.js'

const md5 = require('md5')

const state = {
  userToken: getToken(),
  userInfo: {},
  currentTab: '',
  currentRole: '',
  adminBrand: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.userToken = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_CURRENT_TAB: (state, tab) => {
    state.currentTab = tab
  },
  SET_CURRENT_ROLE: (state, role) => {
    state.currentRole = role
  },
  SET_ADMIN_BRAND: (state, brand) => {
    state.adminBrand = brand
  }
}

const getters = {
  currentTab: state => {
    return state.currentTab
  },
  currentRole: state => {
    return state.currentRole
  },
  adminBrand: state => {
    return state.adminBrand
  },
  userInfo: state => {
    return state.userInfo
  }
}

const actions = {
  register ({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      const body = { ...userInfo }
      body.password = md5(body.password)
      body.password_confirm = md5(body.password_confirm)
      service.post('/api/v1/atk_player/users/register', body).then(function (res) {
        if (res.code === 200) {
          resolve()
        } else {
          reject(Error(res.msg))
        }
      }).catch(function (err) {
        reject(Error(err.msg))
      })
    })
  },
  login ({ commit }, userInfo) {
    const { email, password } = userInfo
    return new Promise((resolve, reject) => {
      service.post('/api/v1/atk_player/users/login', { email, password: md5(password) }).then(function (res) {
        if (res.code === 200) {
          const { token } = res.data
          commit('SET_TOKEN', token)
          setToken(token)
          resolve()
        } else {
          reject(Error(res.msg))
        }
      }).catch(function (err) {
        reject(Error(err.msg))
      })
    })
  },
  invitation ({ commit }, token) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  },
  logout ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      removeToken()
      resolve()
    })
  },
  setCurrentTab ({ commit }, tab) {
    commit('SET_CURRENT_TAB', tab)
  },
  setCurrentRole ({ commit }, role) {
    commit('SET_CURRENT_ROLE', role)
  },
  getUserInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      service.get('/api/v1/atk_player/users/info').then(function (res) {
        if (res.code === 200) {
          const userInfo = res.data
          commit('SET_USER_INFO', userInfo)
          resolve(userInfo)
        } else {
          reject(Error(res.msg))
        }
      }).catch(function (err) {
        reject(err)
      })
    })
  },
  getAdminBrand ({ commit }, brandId) {
    return new Promise((resolve, reject) => {
      service.get(`/api/v1/atk_player/admin/brands/${brandId}`).then(function (res) {
        if (res.code === 200) {
          const brand = res.data
          commit('SET_ADMIN_BRAND', brand)
          resolve(brand)
        } else {
          reject(Error(res.msg))
        }
      }).catch(function (err) {
        reject(err)
      })
    })
  },
  clearAdminBrand ({ commit }) {
    commit('SET_ADMIN_BRAND', {})
  }
}

export default createStore({
  state,
  mutations,
  actions,
  getters,
  modules: {
  }
})
